export interface OrderTotalsRow {
  name: string;
  value: React.ReactNode;
}

interface Props {
  finalPrice: { name: string; value: string };
}

export const OrderTotalsSummary = ({ finalPrice, children }: React.PropsWithChildren<Props>) => {
  return (
    <section>
      <dl className="body-1">
        <div className="divide-y divide-neutral-90">{children}</div>
        <div className="mt-3 flex justify-between text-neutral-20 heading-3">
          <dt>{finalPrice.name}:</dt>
          <dd>{finalPrice.value}</dd>
        </div>
      </dl>
    </section>
  );
};
